import * as React from 'react';
import { PieChart } from "./PieChart";
import { ChartData, ChartDataContext } from "../context/Chart";
import { generateRandomRgb } from "../util/color";

const LABEL = 'Resultaten hoofdstukken';

const convertResultsetToChartData = (data: ChartData,colors: Array<string>) => {

    if(data.result_set && data.result_set.length > 0){
        return data.result_set[0].chapter.map((chapter,index) => {
            return {
                labels: data.result_set[0].result.map(function(c){
                    return c.title;
                }),
                datasets: data.result_set.map((resultSet) => {
                    return {
                        label: resultSet.title,
                        data : resultSet.chapter[index].result.map( function ( result ) {
                            return parseFloat(result.percent.toFixed(1));
                        }),
                        backgroundColor: colors.filter((color,index) => {
                            return index < 4;
                        }),
                        hoverOffset: 4
                    };
                })
            }
        })
    }

    return [];

}

export const ChaptersChart = () : JSX.Element => {
    const colors = [...(new Array(4))].map(() => {
        return generateRandomRgb();
    });

    const [data,] = React.useContext(ChartDataContext);
    const [chaptersData,setChaptersData] = React.useState(convertResultsetToChartData(data,colors));

    React.useEffect(() => {
        if(!data.fetching&&!data.fetch){
            setChaptersData(convertResultsetToChartData(data,colors))
        }
    },[data]);

    const options = {
        plugins: {
            legend: {
                display: true,
                position: 'right' as any
            }
        }
    };

    return <div className={'c-pstats__charts'}>
        <h2>{LABEL}</h2>
        <div className={'c-pstats__charts__chapters'}>
        { data.result_set && data.result_set.length > 0 && data.result_set[0].chapter.map((chapter,index) => {
                return <PieChart key={`pie_chapter_${index}`} data={chaptersData[index]} options={options} label={chapter.title} />
        }) }
        </div>
    </div>;
}
